export default __webpack_public_path__ + "static/media/mirjam.935dd45a.png";